import { useLocation, useNavigate } from 'react-router-dom'
import { Home, Clock, Send, ArrowDownToLine, Settings } from 'lucide-react'

const tabs = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/history', icon: Clock, label: 'Activity' },
    { path: '/send', icon: Send, label: 'Send' },
    { path: '/receive', icon: ArrowDownToLine, label: 'Receive' },
    { path: '/settings', icon: Settings, label: 'Settings' },
]

// Pages where the bottom nav should be completely hidden
const HIDDEN_PATHS = ['/login', '/landing', '/create-wallet', '/help', '/wellswallet']

export function BottomNav() {
    const location = useLocation()
    const navigate = useNavigate()

    if (HIDDEN_PATHS.includes(location.pathname)) {
        return null
    }

    return (
        <nav
            className="fixed bottom-0 left-0 right-0 z-50"
            style={{
                background: 'rgba(10, 10, 15, 0.96)',
                backdropFilter: 'saturate(180%) blur(24px)',
                WebkitBackdropFilter: 'saturate(180%) blur(24px)',
                borderTop: '1px solid rgba(255, 255, 255, 0.06)',
                paddingBottom: 'env(safe-area-inset-bottom, 0px)',
            }}
        >
            <div className="flex items-stretch max-w-lg mx-auto">
                {tabs.map((tab) => {
                    const isActive = location.pathname === tab.path

                    return (
                        <button
                            key={tab.path}
                            onClick={() => navigate(tab.path)}
                            className="flex-1 flex flex-col items-center justify-center min-h-[52px] pt-1.5 pb-1 transition-colors relative active:scale-95"
                            aria-label={tab.label}
                            style={{ WebkitTapHighlightColor: 'transparent' }}
                        >
                            {/* Active indicator pill */}
                            {isActive && (
                                <span
                                    className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-[2.5px] rounded-full"
                                    style={{ background: 'linear-gradient(90deg, #818CF8, #A78BFA)' }}
                                />
                            )}

                            {/* Icon with subtle active background */}
                            <div className={`flex items-center justify-center w-10 h-7 rounded-xl transition-all duration-150 ${isActive ? 'bg-indigo-500/10' : ''}`}>
                                <tab.icon
                                    className={`h-[21px] w-[21px] transition-colors duration-150 ${isActive ? 'text-white' : 'text-white/30'}`}
                                    strokeWidth={isActive ? 2.2 : 1.7}
                                />
                            </div>
                            <span className={`text-[10px] leading-tight font-medium transition-colors duration-150 mt-0.5 ${isActive ? 'text-white/90' : 'text-white/30'}`}>
                                {tab.label}
                            </span>
                        </button>
                    )
                })}
            </div>
        </nav>
    )
}
